import React from 'react';
import { useParams, Link } from 'react-router-dom';
import styled from 'styled-components';

import SettlementAdvance from './SettlementAdvance';

const HumberLogoLink = styled(Link)`
  width: 10pc;
  padding: 14px 14px 0 14px;
  display: block;
  text-decoration: none;
  margin-bottom: 20px;

  img {
    width: 100%;
    cursor: pointer;
  }
`;

const SettlementAdvanceExt = () => {
  const { billingId } = useParams();

  return (
    <>
      <HumberLogoLink to="/carrier">
        <img src="../../../images/icons/humber-logo.png" alt="humber-logo" />
      </HumberLogoLink>
      <SettlementAdvance billingId={billingId} />
    </>
  );
};

export default SettlementAdvanceExt;
